module.exports = __webpack_public_path__ + "img/paid-filter.57ce1bef.svg";